// Request headers
export enum Headers {
  Authorization = 'authorization',
  Accept = 'Accept',
}
